<template>
  <div class="col-12">
    <v-row align="start">
      <template v-if="isOrganization">
        <div class="col-12">
          <h3>
            {{ $vuetify.lang.t("$vuetify.gln.organization_details") }}
          </h3>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-autocomplete
            v-model="form.organization_role"
            :items="getEnumOptions('organization_role')"
            item-text="text"
            item-value="value"
            multiple
            chips
            clearable
            :label="$vuetify.lang.t('$vuetify.gln.organization_role')"
            :error="showError('organization_role')"
            :error-messages="errorMessage('organization_role')"
            @change="$emit('validate')"
          ></v-autocomplete>
        </div>
        <GlnRepeatableRows
          v-model="form.additional_organization_id"
          value-field="organization_id"
          type-field="organization_id_type"
          :value-label="$vuetify.lang.t('$vuetify.gln.organization_id')"
          :type-label="$vuetify.lang.t('$vuetify.gln.organization_id_type')"
          :add-label="$vuetify.lang.t('$vuetify.gln.add_organization_id')"
          :remove-label="$vuetify.lang.t('$vuetify.gln.remove_row')"
          :type-options="getEnumOptions('additional_organization_id_type')"
          :errors="errors"
          error-prefix="additional_organization_id_"
          :show-errors="submitAttempted"
        />
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-text-field
            v-model="form.parent_organization_gln"
            :label="$vuetify.lang.t('$vuetify.gln.parent_organization_gln')"
            :error="showError('parent_organization_gln')"
            :error-messages="errorMessage('parent_organization_gln')"
            @input="$emit('validate')"
          ></v-text-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-select
            v-model="form.parent_organization_gln_type"
            :items="getEnumOptions('parent_organization_gln_type')"
            item-text="text"
            item-value="value"
            clearable
            :label="
              $vuetify.lang.t('$vuetify.gln.parent_organization_gln_type')
            "
            :error="showError('parent_organization_gln_type')"
            :error-messages="errorMessage('parent_organization_gln_type')"
            @change="$emit('validate')"
          ></v-select>
        </div>
        <div class="col-12">
          <h4>{{ $vuetify.lang.t("$vuetify.gln.related_locations") }}</h4>
        </div>
        <GlnRepeatableRows
          v-model="form.location"
          value-field="gln"
          type-field="gln_type"
          :value-label="$vuetify.lang.t('$vuetify.gln.related_gln')"
          :type-label="$vuetify.lang.t('$vuetify.gln.related_gln_type')"
          :add-label="$vuetify.lang.t('$vuetify.gln.add_related_location')"
          :remove-label="$vuetify.lang.t('$vuetify.gln.remove_row')"
          :type-options="getEnumOptions('location_gln_type')"
          :errors="errors"
          error-prefix="location_"
          :show-errors="submitAttempted"
          :limit-error="errorMessage('location')"
        />
        <div class="col-12">
          <h4>
            {{ $vuetify.lang.t("$vuetify.gln.organization_postal_address") }}
          </h4>
        </div>
        <div class="col-12 body-2 grey--text text--darken-1">
          {{ $vuetify.lang.t("$vuetify.gln.address_optional_hint") }}
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-select
            v-model="form.address_country_code"
            :items="getEnumOptions('address_country_code')"
            item-text="text"
            item-value="value"
            clearable
            :label="$vuetify.lang.t('$vuetify.gln.address_country_code')"
            :error="showError('address_country_code')"
            :error-messages="errorMessage('address_country_code')"
            @change="$emit('validate')"
          ></v-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-text-field
            v-model="form.address_locality.ka"
            :label="$vuetify.lang.t('$vuetify.gln.address_locality_ka')"
            :error="showError('address_ka')"
            :error-messages="errorMessage('address_ka')"
            @input="$emit('validate')"
          ></v-text-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-text-field
            v-model="form.address_postal_name.ka"
            :label="$vuetify.lang.t('$vuetify.gln.address_postal_name_ka')"
            :error="showError('address_ka')"
            @input="$emit('validate')"
          ></v-text-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-text-field
            v-model="form.address_locality.en"
            :label="$vuetify.lang.t('$vuetify.gln.address_locality_en')"
            :error="showError('address_en')"
            :error-messages="errorMessage('address_en')"
            @input="$emit('validate')"
          ></v-text-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-text-field
            v-model="form.address_postal_name.en"
            :label="$vuetify.lang.t('$vuetify.gln.address_postal_name_en')"
            :error="showError('address_en')"
            @input="$emit('validate')"
          ></v-text-field>
        </div>
      </template>

      <template v-if="isLocation">
        <div class="col-12">
          <h3>{{ $vuetify.lang.t("$vuetify.gln.location_details") }}</h3>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <v-autocomplete
            v-model="form.location_role"
            :items="getEnumOptions('location_role')"
            item-text="text"
            item-value="value"
            multiple
            chips
            clearable
            :label="$vuetify.lang.t('$vuetify.gln.location_role')"
            :error="showError('location_role')"
            :error-messages="errorMessage('location_role')"
            @change="$emit('validate')"
          ></v-autocomplete>
        </div>
        <GlnRepeatableRows
          v-model="form.additional_location_id"
          value-field="location_id"
          type-field="location_id_type"
          :value-label="$vuetify.lang.t('$vuetify.gln.location_id')"
          :type-label="$vuetify.lang.t('$vuetify.gln.location_id_type')"
          :add-label="$vuetify.lang.t('$vuetify.gln.add_location_id')"
          :remove-label="$vuetify.lang.t('$vuetify.gln.remove_row')"
          :type-options="getEnumOptions('additional_location_id_type')"
          :errors="errors"
          error-prefix="additional_location_id_"
          :show-errors="submitAttempted"
        />
        <div class="col-12">
          <h4>
            {{ $vuetify.lang.t("$vuetify.gln.related_organizations") }}
          </h4>
        </div>
        <GlnRepeatableRows
          v-model="form.related_organization"
          value-field="gln"
          type-field="gln_type"
          :value-label="$vuetify.lang.t('$vuetify.gln.related_gln')"
          :type-label="$vuetify.lang.t('$vuetify.gln.related_gln_type')"
          :add-label="$vuetify.lang.t('$vuetify.gln.add_related_organization')"
          :remove-label="$vuetify.lang.t('$vuetify.gln.remove_row')"
          :type-options="getEnumOptions('related_organization_gln_type')"
          :errors="errors"
          error-prefix="related_organization_"
          :show-errors="submitAttempted"
          :limit-error="errorMessage('related_organization')"
        />
      </template>

      <div v-if="isFixedPhysicalLocation" class="col-xs-12 col-sm-12 col-md-6">
        <v-text-field
          v-model="form.contained_in_place_gln"
          :label="$vuetify.lang.t('$vuetify.gln.contained_in_place_gln')"
          :error="showError('contained_in_place_gln')"
          :error-messages="errorMessage('contained_in_place_gln')"
          @input="$emit('validate')"
        ></v-text-field>
      </div>
      <div v-if="isMobilePhysicalLocation" class="col-xs-12 col-sm-12 col-md-6">
        <v-text-field
          v-model="form.base_location_gln"
          :label="$vuetify.lang.t('$vuetify.gln.base_location_gln')"
          :error="showError('base_location_gln')"
          :error-messages="errorMessage('base_location_gln')"
          @input="$emit('validate')"
        ></v-text-field>
      </div>
    </v-row>
  </div>
</template>

<script>
import GlnRepeatableRows from "./GlnRepeatableRows.vue";

export default {
  components: { GlnRepeatableRows },
  props: {
    form: { type: Object, required: true },
    isOrganization: Boolean,
    isLocation: Boolean,
    isFixedPhysicalLocation: Boolean,
    isMobilePhysicalLocation: Boolean,
    getEnumOptions: { type: Function, required: true },
    errors: { type: Object, default: () => ({}) },
    submitAttempted: Boolean,
  },
  methods: {
    showError(field) {
      return this.submitAttempted && !!this.errors[field];
    },
    errorMessage(field) {
      return this.submitAttempted ? this.errors[field] || null : null;
    },
  },
};
</script>
